import { Observable } from "rxjs";
import { ProductCost } from "@planard/@core/entities/productCost";

export abstract class ProductCostData {
  abstract listPrices(
    scenarioId: number,
    approveRequestId?: number
  ): Observable<any>;

  abstract update(plan: ProductCost): Observable<any>;
}
